export default {
    install(app, _) {
      app.config.globalProperties.$className = {
        input: 'contact-textbox',
        textarea: 'contact-textarea',
        radio: {
          root: 'contact-item',
          input: 'contact-radio',
          label: 'contact-radio__label'
        },
        select: {
          root: 'contact-select'
        },
        error: 'error',
        editableField: {
          root: 'contact-entry__user contct__area',
          text: 'contact-entry__user-text',
          editButton: 'contact-entry__user-rewrite'
        },
        m3LoginLink: {
          root: 'm3phkn-m3comlogin',
          link: 'm3phkn-m3comlogin__btn'
        }
      };
    } 
  }; 